// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static-content/footer/js/" + ({"523":"template-chelsea-footer","791":"template-standard-footer"}[chunkId] || chunkId) + "." + {"523":"f62133c2","674":"5b0d459c","791":"f7fe0bc0","876":"02a54c8c"}[chunkId] + ".chunk.js";
};